// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import Colors from "../../../Constants/Colors";
// import InputComponent from "../../CreateQuestionsPaper/TestScheduling/Input-testscheduling";
// import EndPoints from "../../../Api/EndPoints";
// import { GET, PUT } from "../../../Api/HttpsMethods";
// import TableForUserEdit from "../../../Components/TableComponent/TableForUserEdit";
// import TableForAccessView from "../../../Components/TableComponent/TableForAccessView";
// import InputComponent2 from "../../../Components/InputComponents/InputComponent";
// import DropDown from "../../CreateQuestionsPaper/DppScheduling/ReflectDropdownClassic";
// import MinusImg from "../../../Assets/Images/CommanImages/MinusGrey.png";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
// import SuccessImg from "../../../Assets/Images/CommanImages/success.png";
// import InterogativeImg from "../../../Assets/Images/CommanImages/Interogative.png";
// import { FULL_API_BASE_URL } from "../../../Config/Config";

// /**
//  * UserEditFromDashboard
//  * - Calls: GET /coaching-collaborator-api/api/v1/get-user-group-role-screen-report-access-details-by-user-id?user_id=<UserId>
//  * - Sends Authorization: Bearer <token> when available.
//  * - Shows auth error message in message box if token missing or invalid.
//  * - Shows "No screens available" centered when API returns empty data.
//  */

// const UserEditFromDashboard = ({ dataClient, messageBox, setIsMessageBoxVisible, setActiveImg, setMessageBox }) => {
//   const [employeeData, setEmployeeData] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [userNameForShow, setUserNameForShow] = useState("");
//   const [appAccess, setAppAccess] = useState("");
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [UserStatus, setUserStatus] = useState("");
//   const location = useLocation();
//   const navigate = useNavigate();

//   const sampleHeaders = ["User Groups", "Roles", "Screens", "Reports"];
//   const [assignedRoles, setAssignedRoles] = useState([]);
//   const [groupedRows, setGroupedRows] = useState([]);

//   const accessToken = localStorage.getItem("other"); // token used for Authorization
//   const ModifierUser = dataClient?.client_schema_name?.[6]?.[0]?.user_name || sessionStorage.getItem("user_name") || "";
//   const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || localStorage.getItem("clientId") || sessionStorage.getItem("clientId");
//   const UserId = new URLSearchParams(location.search).get("UserID") || ""; // user_id to send to API
//   const loggedInUserId = dataClient?.dataClient?.client_schema_name?.[6]?.[0]?.user_id || localStorage.getItem("userId") || sessionStorage.getItem("userId");
//   const isSameUser = UserId && loggedInUserId && UserId === loggedInUserId.toString();

//   useEffect(() => {
//     const usernameFromUrl = new URLSearchParams(location.search).get("UsernameOfEmployee");
//     if (usernameFromUrl) setUserNameForShow(usernameFromUrl);
//   }, [location.search]);

//   const appAccessOptions = [
//     { label: "Web Portal", id: "Web Portal" },
//     { label: "Mobile Application", id: "Mobile Application" },
//     { label: "Both", id: "Both" },
//   ];

//   // fetchRoles kept for compatibility (your code had it)
//   const fetchRoles = async () => {
//     try {
//       if (EndPoints.GetRoles) await GET.noToken(EndPoints.GetRoles);
//     } catch (err) {
//       console.error("Error fetching roles:", err);
//     }
//   };

//   useEffect(() => {
//     fetchRoles();
//     // eslint-disable-next-line
//   }, []);

//   // Fetch employee data (unchanged)
//   const fetchEmployeeData = async (searchKey) => {
//     try {
//       setLoading(true);
//       if (setMessageBox) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>Loading employee data...</span>
//             </div>
//           </div>
//         );
//         setActiveImg && setActiveImg(SuccessImg);
//         setIsMessageBoxVisible && setIsMessageBoxVisible(true);
//       }

//       const url = `${EndPoints.GetEmployeeBySearchKey}?search_key=${searchKey}`;
//       const data = await GET.noToken(url);

//       if (data && data.length > 0) {
//         setEmployeeData(data[0]);
//         setAppAccess(getAppAccessValue(data[0].mobile_app_user, data[0].web_app_user));
//         setUserStatus(data[0].user_status || "");
//       } else {
//         setError("No employee data found");
//       }
//     } catch (err) {
//       setError(`Failed to fetch employee data: ${err.message}`);
//       console.error("Error fetching employee data:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const searchKey = new URLSearchParams(location.search).get("MNTQuestionNumbers");
//     if (searchKey) fetchEmployeeData(searchKey);
//     else {
//       setError(null);
//       setLoading(false);
//     }
//     // eslint-disable-next-line
//   }, [location.search]);

//   // New: fetch user groups/access info from API using only user_id and send Authorization header
//   useEffect(() => {
//     const fetchAccessInfo = async () => {
//       if (!UserId) {
//         setGroupedRows([]);
//         return;
//       }

//       // if no token, show message and still try if your API allows anonymous (but here it returned auth error)
//       if (!accessToken) {
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>Not authenticated (missing token). Please login.</span>
//               </div>
//             </div>
//           );
//           setActiveImg && setActiveImg(ErrorImg);
//           setIsMessageBoxVisible && setIsMessageBoxVisible(true);
//         }
//         setGroupedRows([]);
//         return;
//       }

//       try {
//         const base = EndPoints.GetUserGroupAccessByUserId || `${FULL_API_BASE_URL}/get-user-group-role-screen-report-access-details-by-user-id`;
//         const url = `${base}?user_id=${encodeURIComponent(UserId)}`;

//         const res = await fetch(url, {
//           method: "GET",
//           headers: {
//             Accept: "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//         });

//         // handle authentication errors explicitly
//         if (res.status === 401 || res.status === 403) {
//           const txt = await res.text().catch(() => "");
//           const shortMsg = txt || "Not authenticated";
//           if (setMessageBox) {
//             setMessageBox(
//               <div className="Container-messageBOX">
//                 <div className="messagebox-insider1">
//                   <div className="loader-tc"></div>
//                   <span>{shortMsg}</span>
//                 </div>
//               </div>
//             );
//             setActiveImg && setActiveImg(ErrorImg);
//             setIsMessageBoxVisible && setIsMessageBoxVisible(true);
//           }
//           setGroupedRows([]);
//           return;
//         }

//         const json = await res.json().catch(() => null);

//         // API expected format: { status:200, message, data: [...] } OR directly an array
//         let dataArray = [];
//         if (!json) {
//           dataArray = [];
//         } else if (Array.isArray(json)) {
//           dataArray = json;
//         } else if (Array.isArray(json.data)) {
//           dataArray = json.data;
//         } else {
//           dataArray = [];
//         }

//         if (dataArray.length > 0) {
//           setGroupedRows(dataArray);
//         } else {
//           setGroupedRows([]);
//           // show subtle message (but don't spam) — keep quiet here unless you want visible message
//         }
//       } catch (err) {
//         console.error("Error fetching access info:", err);
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>Error fetching access info</span>
//               </div>
//             </div>
//           );
//           setActiveImg && setActiveImg(ErrorImg);
//           setIsMessageBoxVisible && setIsMessageBoxVisible(true);
//         }
//         setGroupedRows([]);
//       }
//     };

//     fetchAccessInfo();
//     // eslint-disable-next-line
//   }, [UserId, accessToken]);

//   const renderQuestionText = (text) => (text ? text : "");
//   const renderQuestionTextModel = (text) => (text ? text : "");

//   const handleEditClick = () => setIsEditMode(true);

//   const handleSaveClick = async () => {
//     try {
//       let webUserFlag = 0;
//       let appUserFlag = 0;
//       if (appAccess === "Both") {
//         webUserFlag = 1;
//         appUserFlag = 1;
//       } else if (appAccess === "Mobile Application") {
//         appUserFlag = 1;
//         webUserFlag = 0;
//       } else if (appAccess === "Web Portal") {
//         webUserFlag = 1;
//         appUserFlag = 0;
//       }
//       const url = `${EndPoints.UpdateUser}?username=${userNameForShow}&modified_by=${ModifierUser}&web_user_flag=${webUserFlag}&app_user_flag=${appUserFlag}`;
//       const result = await PUT.withToken(url, assignedRoles);
//       if (result?.status === 200) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{result?.message || "User Data Updated successfully"}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(SuccessImg);
//         setIsMessageBoxVisible(true);
//         setTimeout(() => {
//           setIsMessageBoxVisible(false);
//           navigate(-1);
//         }, 1500);
//       } else {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{result?.message || "User Data Could not Update"}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//       }
//     } catch (err) {
//       console.error("Error saving data:", err);
//       alert("Failed to save data");
//     }
//   };

//   const handleCancelClick = () => navigate(-1);

//   const getAppAccessValue = (mobile_app_user, webUserValue) => {
//     if (mobile_app_user === 1 && webUserValue === 1) return "Both";
//     if (mobile_app_user === 1 && webUserValue !== 1) return "Mobile Application";
//     if (webUserValue === 1 && mobile_app_user !== 1) return "Web Portal";
//     return "";
//   };

//   const handleStatusToggleClick = () => {
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
//           <div style={{ display: "flex", gap: "15px" }}>
//             <div className="loader-tc"></div>
//             <span style={{ textAlign: "left", flex: "1" }}>Are you sure you want to {UserStatus === "Inactive" ? "activate" : "deactivate"} this user?</span>
//           </div>
//           <div style={{ display: "flex", gap: "15px" }}>
//             <button className="create-test-section-btn-v3" onClick={executeStatusToggle} style={{ boxShadow: "0px 4px 4px 0px #00000040" }}>OK</button>
//             <button className="create-test-section-btn-v3" onClick={handleCancelConfirmation} style={{ boxShadow: "0px 4px 4px 0px #00000040" }}>CANCEL</button>
//           </div>
//         </div>
//       </div>
//     );
//     setActiveImg(InterogativeImg);
//     setIsMessageBoxVisible(true);
//   };

//   const executeStatusToggle = async () => {
//     setIsMessageBoxVisible(false);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Processing...</span>
//         </div>
//       </div>
//     );
//     setActiveImg(SuccessImg);
//     setIsMessageBoxVisible(true);

//     try {
//       const flag = UserStatus === "Inactive" ? 1 : 0;
//       const url = `${EndPoints.ActivateDeactivateUser}?username=${userNameForShow}&client_id=${clientId}&flag=${flag}&modified_by=${ModifierUser}`;
//       const response = await fetch(url, { method: "PATCH", headers: { accept: "application/json", Authorization: `Bearer ${accessToken}` } });
//       if (!response.ok) throw new Error(`Failed: ${response.status}`);
//       const result = await response.json();
//       if (result.status === 200) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{result?.message || `User ${flag === 1 ? "activated" : "deactivated"} successfully`}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(SuccessImg);
//         setIsMessageBoxVisible(true);
//         setTimeout(() => {
//           setIsMessageBoxVisible(false);
//           navigate(-1);
//         }, 1500);
//       } else {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{result?.message || "User not Updated"}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//       }
//     } catch (err) {
//       console.error("Error toggling user status:", err);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{`Failed to ${UserStatus === "Inactive" ? "activate" : "deactivate"} user`}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//       setIsMessageBoxVisible(true);
//     }
//   };

//   const handleCancelConfirmation = () => setIsMessageBoxVisible(false);

//   const handleResetPassword = () => {
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
//           <div style={{ display: "flex", gap: "15px" }}>
//             <div className="loader-tc"></div>
//             <span style={{ textAlign: "left", flex: "1" }}>Are you sure you want to reset the password for this user?</span>
//           </div>
//           <div style={{ display: "flex", gap: "15px" }}>
//             <button className="create-test-section-btn-v3" onClick={executeResetPassword} style={{ boxShadow: "0px 4px 4px 0px #00000040" }}>OK</button>
//             <button className="create-test-section-btn-v3" onClick={handleCancelConfirmation} style={{ boxShadow: "0px 4px 4px 0px #00000040" }}>CANCEL</button>
//           </div>
//         </div>
//       </div>
//     );
//     setActiveImg(InterogativeImg);
//     setIsMessageBoxVisible(true);
//   };

//   const executeResetPassword = async () => {
//     setIsMessageBoxVisible(false);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Processing password reset...</span>
//         </div>
//       </div>
//     );
//     setActiveImg(SuccessImg);
//     setIsMessageBoxVisible(true);

//     try {
//       if (!userNameForShow || !ModifierUser) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>User information not available for password reset.</span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//         return;
//       }

//       const url = `${EndPoints.UpdateUser}?username=${userNameForShow}&modified_by=${ModifierUser}&reset_password_flag=1`;
//       const response = await fetch(url, { method: "PUT", headers: { accept: "application/json", Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" }, body: JSON.stringify([]) });
//       if (!response.ok) throw new Error(`Reset password failed with status ${response.status}`);
//       const result = await response.json();

//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{result?.message || "Password reset successfully!"}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(SuccessImg);
//       setIsMessageBoxVisible(true);

//       localStorage.removeItem("isLoggedIn");
//       localStorage.removeItem("userId");
//       localStorage.removeItem("clientId");
//       setTimeout(() => setIsMessageBoxVisible(false), 2000);
//       setTimeout(() => window.location.reload(), 1000);
//     } catch (error) {
//       console.error("Error resetting password:", error);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{`Password reset failed: ${error.message}`}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//       setIsMessageBoxVisible(true);
//     }
//   };

//   const handleDeleteRoleFromGroup = (groupName, roleNameToRemove) => {
//     setGroupedRows((prev) => prev.map((g) => (g.group_name === groupName ? { ...g, roles: g.roles.filter((r) => r.role_name !== roleNameToRemove) } : g)));
//   };

//   return (
//     <div className="Leftmargin-Main-DIV">
//       <div style={{ position: "sticky", top: 0, backgroundColor: "white", zIndex: 100 }}>
//         <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "20px", width: "98%" }}>
//           <div style={{ fontSize: "30px", color: `${Colors.color1}`, fontWeight: "400" }}>Application User Details</div>
//           <div>
//             <div className="row-cs-uni">
//               <button className="create-test-section-btn" style={{ marginRight: "18px", boxShadow: "0px 4px 4px 0px #00000040" }} onClick={handleCancelClick}>CANCEL</button>
//               <button className="create-test-section-btn" style={{ marginRight: "18px", boxShadow: "0px 4px 4px 0px #00000040", width: "150px", opacity: isSameUser ? 0.5 : 1, cursor: isSameUser ? "not-allowed" : "pointer" }} onClick={handleResetPassword} disabled={isSameUser}>RESET PASSWORD</button>
//               <button className="create-test-section-btn" style={{ marginRight: "18px", boxShadow: "0px 4px 4px 0px #00000040" }} onClick={handleStatusToggleClick}>{UserStatus === "Inactive" ? "ACTIVATE" : "DEACTIVATE"}</button>
//               {!isEditMode ? <button className="create-test-section-btn" style={{ marginRight: "0px" }} onClick={handleEditClick}>EDIT</button> : <button className="create-test-section-btn" style={{ marginRight: "0px" }} onClick={handleSaveClick}>SAVE</button>}
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="Header-1-C424342" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "5px" }}>
//         <span>USER INFORMATION</span>
//         <img src={MinusImg} alt="Toggle" style={{ cursor: "pointer", width: "24px", height: "10px" }} />
//       </div>

//       <div className="Body-1-C424342" style={{ paddingBottom: "10px" }}>
//         <div className="row-cs-uni">
//           <div className="col-cs-uni"><InputComponent2 label="User Name" value={userNameForShow} style={{ width: "95%" }} isRequired={false} disable={true} /></div>
//           <div className="col-cs-uni"><InputComponent label="Employee Name" value={`${employeeData.emp_first_name || ""} ${employeeData.emp_middle_name || ""} ${employeeData.emp_last_name || ""}`.trim()} style={{ width: "95%" }} isRequired={false} disable={true} /></div>
//           <div className="col-cs-uni"><InputComponent label="Employee ID" value={employeeData.staff_number || ""} style={{ width: "95%" }} isRequired={false} disable={true} /></div>
//         </div>

//         <div className="row-cs-uni">
//           <div className="col-cs-uni"><InputComponent label="Department" value={employeeData.department || ""} style={{ width: "95%" }} isRequired={false} disable={true} /></div>
//           <div className="col-cs-uni"><InputComponent label="Designation" value={employeeData.designation || ""} style={{ width: "95%" }} isRequired={false} disable={true} /></div>
//           <div className="col-cs-uni"><InputComponent label="Manager Name" value={employeeData.manager_name || "Not Assigned"} style={{ width: "95%" }} isRequired={false} disable={true} /></div>
//         </div>

//         <div className="row-cs-uni">
//           <div className="col-cs-uni"><InputComponent label="User Status" value={UserStatus || ""} style={{ width: "95%" }} isRequired={false} disable={true} /></div>
//           <div className="col-cs-uni">{!isEditMode ? <InputComponent label="Application Access" value={appAccess || "Not Set"} style={{ width: "95%" }} isRequired={false} disable={true} /> : <DropDown label="Application Access" style={{ width: "95%" }} setSelected={setAppAccess} selected={appAccess} options={appAccessOptions} isRequired={true} />}</div>
//           <div className="col-cs-uni"><InputComponent label="Approved by" value={employeeData.approved_by || ""} style={{ width: "95%" }} isRequired={false} disable={true} /></div>
//         </div>
//       </div>

//       <div className="Header-1-C424342" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "5px", marginTop: "30px" }}>
//         <span>USER GROUPS</span>
//         <img src={MinusImg} alt="Toggle" style={{ cursor: "pointer", width: "24px", height: "10px" }} />
//       </div>

//       <div className="Body-1-C424342" style={{ marginBottom: "50px" }}>
//         {Array.isArray(groupedRows) && groupedRows.length > 0 ? (
//           <TableForAccessView
//             headers={sampleHeaders}
//             data={groupedRows}
//             searchPlaceholder="Search user groups..."
//             selectedRows={[]}
//             setSelectedRows={() => {}}
//             renderQuestionText={renderQuestionText}
//             renderQuestionTextModel={renderQuestionTextModel}
//             expandedStates={{}}
//             toggleImage={() => {}}
//             questionDetailsMap={{}}
//             handleEyeClick={() => {}}
//             pageType="userGroups"
//             onRowLinkClick={(row) => console.log("Row clicked:", row)}
//             filterConfig={{}}
//             handleDeleteRow={(payload) => {
//               handleDeleteRoleFromGroup(payload.groupName, payload.roleName);
//             }}
//           />
//         ) : (
//           <div style={{ padding: "28px 0", textAlign: "center", color: "#999", fontStyle: "italic" }}>
//             No screens available
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default UserEditFromDashboard;

// UserEditFromDashboard.jsx
// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import Colors from "../../../Constants/Colors";
// import InputComponent from "../../CreateQuestionsPaper/TestScheduling/Input-testscheduling";
// import EndPoints from "../../../Api/EndPoints";
// import { GET, PUT } from "../../../Api/HttpsMethods";
// import TableForUserEdit from "../../../Components/TableComponent/TableForUserEdit";
// import TableForAccessView from "../../../Components/TableComponent/TableForAccessView";
// import InputComponent2 from "../../../Components/InputComponents/InputComponent";
// import DropDown from "../../CreateQuestionsPaper/DppScheduling/ReflectDropdownClassic";
// import MinusImg from "../../../Assets/Images/CommanImages/MinusGrey.png";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
// import SuccessImg from "../../../Assets/Images/CommanImages/success.png";
// import InterogativeImg from "../../../Assets/Images/CommanImages/Interogative.png";
// import { FULL_API_BASE_URL } from "../../../Config/Config";

// /**
//  * UserEditFromDashboard
//  * - Calls: GET /coaching-collaborator-api/api/v1/get-user-group-role-screen-report-access-details-by-user-id?user_id=<UserId>
//  * - Sends Authorization: Bearer <token> when available.
//  * - Shows auth error message in message box if token missing or invalid.
//  * - Shows "No screens available" centered when API returns empty data.
//  */

// const UserEditFromDashboard = ({ dataClient, messageBox, setIsMessageBoxVisible, setActiveImg, setMessageBox }) => {
//   const [employeeData, setEmployeeData] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [userNameForShow, setUserNameForShow] = useState("");
//   const [appAccess, setAppAccess] = useState("");
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [UserStatus, setUserStatus] = useState("");
//   const location = useLocation();
//   const navigate = useNavigate();

//   const sampleHeaders = ["User Groups", "Roles", "Screens", "Reports"];
//   const [assignedRoles, setAssignedRoles] = useState([]);
//   const [groupedRows, setGroupedRows] = useState([]);

//   const accessToken = localStorage.getItem("other"); // token used for Authorization
//   const ModifierUser = dataClient?.client_schema_name?.[6]?.[0]?.user_name || sessionStorage.getItem("user_name") || "";
//   const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || localStorage.getItem("clientId") || sessionStorage.getItem("clientId");
//   const UserId = new URLSearchParams(location.search).get("UserID") || ""; // user_id to send to API
//   const loggedInUserId = dataClient?.dataClient?.client_schema_name?.[6]?.[0]?.user_id || localStorage.getItem("userId") || sessionStorage.getItem("userId");
//   const isSameUser = UserId && loggedInUserId && UserId === loggedInUserId.toString();

//   useEffect(() => {
//     const usernameFromUrl = new URLSearchParams(location.search).get("UsernameOfEmployee");
//     if (usernameFromUrl) setUserNameForShow(usernameFromUrl);
//   }, [location.search]);

//   const appAccessOptions = [
//     { label: "Web Portal", id: "Web Portal" },
//     { label: "Mobile Application", id: "Mobile Application" },
//     { label: "Both", id: "Both" },
//   ];

//   // fetchRoles kept for compatibility (your code had it)
//   const fetchRoles = async () => {
//     try {
//       if (EndPoints.GetRoles) await GET.noToken(EndPoints.GetRoles);
//     } catch (err) {
//       console.error("Error fetching roles:", err);
//     }
//   };

//   useEffect(() => {
//     fetchRoles();
//     // eslint-disable-next-line
//   }, []);

//   // Fetch employee data (unchanged)
//   const fetchEmployeeData = async (searchKey) => {
//     try {
//       setLoading(true);
//       if (setMessageBox) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>Loading employee data...</span>
//             </div>
//           </div>
//         );
//         setActiveImg && setActiveImg(SuccessImg);
//         setIsMessageBoxVisible && setIsMessageBoxVisible(true);
//       }

//       const url = `${EndPoints.GetEmployeeBySearchKey}?search_key=${searchKey}`;
//       const data = await GET.noToken(url);

//       if (data && data.length > 0) {
//         setEmployeeData(data[0]);
//         setAppAccess(getAppAccessValue(data[0].mobile_app_user, data[0].web_app_user));
//         setUserStatus(data[0].user_status || "");
//       } else {
//         setError("No employee data found");
//       }
//     } catch (err) {
//       setError(`Failed to fetch employee data: ${err.message}`);
//       console.error("Error fetching employee data:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const searchKey = new URLSearchParams(location.search).get("MNTQuestionNumbers");
//     if (searchKey) fetchEmployeeData(searchKey);
//     else {
//       setError(null);
//       setLoading(false);
//     }
//     // eslint-disable-next-line
//   }, [location.search]);

//   // New: fetch user groups/access info from API using only user_id and send Authorization header
//   useEffect(() => {
//     const fetchAccessInfo = async () => {
//       if (!UserId) {
//         setGroupedRows([]);
//         return;
//       }

//       // if no token, show message and still try if your API allows anonymous (but here it returned auth error)
//       if (!accessToken) {
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>Not authenticated (missing token). Please login.</span>
//               </div>
//             </div>
//           );
//           setActiveImg && setActiveImg(ErrorImg);
//           setIsMessageBoxVisible && setIsMessageBoxVisible(true);
//         }
//         setGroupedRows([]);
//         return;
//       }

//       try {
//         const base = EndPoints.GetUserGroupAccessByUserId || `${FULL_API_BASE_URL}/get-user-group-role-screen-report-access-details-by-user-id`;
//         const url = `${base}?user_id=${encodeURIComponent(UserId)}`;

//         const res = await fetch(url, {
//           method: "GET",
//           headers: {
//             Accept: "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//         });

//         // handle authentication errors explicitly
//         if (res.status === 401 || res.status === 403) {
//           const txt = await res.text().catch(() => "");
//           const shortMsg = txt || "Not authenticated";
//           if (setMessageBox) {
//             setMessageBox(
//               <div className="Container-messageBOX">
//                 <div className="messagebox-insider1">
//                   <div className="loader-tc"></div>
//                   <span>{shortMsg}</span>
//                 </div>
//               </div>
//             );
//             setActiveImg && setActiveImg(ErrorImg);
//             setIsMessageBoxVisible && setIsMessageBoxVisible(true);
//           }
//           setGroupedRows([]);
//           return;
//         }

//         const json = await res.json().catch(() => null);

//         // API expected format: { status:200, message, data: [...] } OR directly an array
//         let dataArray = [];
//         if (!json) {
//           dataArray = [];
//         } else if (Array.isArray(json)) {
//           dataArray = json;
//         } else if (Array.isArray(json.data)) {
//           dataArray = json.data;
//         } else {
//           dataArray = [];
//         }

//         if (dataArray.length > 0) {
//           setGroupedRows(dataArray);
//         } else {
//           setGroupedRows([]);
//           // show subtle message (but don't spam) — keep quiet here unless you want visible message
//         }
//       } catch (err) {
//         console.error("Error fetching access info:", err);
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>Error fetching access info</span>
//               </div>
//             </div>
//           );
//           setActiveImg && setActiveImg(ErrorImg);
//           setIsMessageBoxVisible && setIsMessageBoxVisible(true);
//         }
//         setGroupedRows([]);
//       }
//     };

//     fetchAccessInfo();
//     // eslint-disable-next-line
//   }, [UserId, accessToken]);

//   const renderQuestionText = (text) => (text ? text : "");
//   const renderQuestionTextModel = (text) => (text ? text : "");

//   const handleEditClick = () => setIsEditMode(true);

//   const handleSaveClick = async () => {
//     try {
//       let webUserFlag = 0;
//       let appUserFlag = 0;
//       if (appAccess === "Both") {
//         webUserFlag = 1;
//         appUserFlag = 1;
//       } else if (appAccess === "Mobile Application") {
//         appUserFlag = 1;
//         webUserFlag = 0;
//       } else if (appAccess === "Web Portal") {
//         webUserFlag = 1;
//         appUserFlag = 0;
//       }
//       const url = `${EndPoints.UpdateUser}?username=${userNameForShow}&modified_by=${ModifierUser}&web_user_flag=${webUserFlag}&app_user_flag=${appUserFlag}`;
//       const result = await PUT.withToken(url, assignedRoles);
//       if (result?.status === 200) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{result?.message || "User Data Updated successfully"}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(SuccessImg);
//         setIsMessageBoxVisible(true);
//         setTimeout(() => {
//           setIsMessageBoxVisible(false);
//           navigate(-1);
//         }, 1500);
//       } else {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{result?.message || "User Data Could not Update"}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//       }
//     } catch (err) {
//       console.error("Error saving data:", err);
//       alert("Failed to save data");
//     }
//   };

//   const handleCancelClick = () => navigate(-1);

//   const getAppAccessValue = (mobile_app_user, webUserValue) => {
//     if (mobile_app_user === 1 && webUserValue === 1) return "Both";
//     if (mobile_app_user === 1 && webUserValue !== 1) return "Mobile Application";
//     if (webUserValue === 1 && mobile_app_user !== 1) return "Web Portal";
//     return "";
//   };

//   // const handleStatusToggleClick = () => {
//   //   setMessageBox(
//   //     <div className="Container-messageBOX">
//   //       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
//   //         <div style={{ display: "flex", gap: "15px" }}>
//   //           <div className="loader-tc"></div>
//   //           <span style={{ textAlign: "left", flex: "1" }}>Are you sure you want to {UserStatus === "Inactive" ? "activate" : "deactivate"} this user?</span>
//   //         </div>
//   //         <div style={{ display: "flex", gap: "15px" }}>
//   //           <button className="create-test-section-btn-v3" onClick={executeStatusToggle} style={{ boxShadow: "0px 4px 4px 0px #00000040" }}>OK</button>
//   //           <button className="create-test-section-btn-v3" onClick={handleCancelConfirmation} style={{ boxShadow: "0px 4px 4px 0px #00000040" }}>CANCEL</button>
//   //         </div>
//   //       </div>
//   //     </div>
//   //   );
//   //   setActiveImg(InterogativeImg);
//   //   setIsMessageBoxVisible(true);
//   // };

//   const handleStatusToggleClick = () => {
//     const isActivating = UserStatus === "Inactive";

//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>
//             {isActivating
//               ? "Are you sure you want to activate this user?"
//               : "Are you sure you want to deactivate this user?"}
//           </span>
//         </div>

//         <div
//           className="messagebox-insider2"
//           style={{
//             display: "flex",
//             gap: "10px",
//             marginTop: "10px",
//             justifyContent: "flex-end",
//           }}
//         >
//           {/* YES button */}
//           <button
//             className="messagebox-cancel-btn-ok"
//             onClick={() => {
//               setIsMessageBoxVisible(false);
//               executeStatusToggle(); // same logic as before
//             }}
//           >
//             YES
//           </button>

//           {/* NO button */}
//           <button
//             className="messagebox-cancel-btn-ok"
//             onClick={() => {
//               setIsMessageBoxVisible(false);
//               handleCancelConfirmation(); // same cancel callback as before
//             }}
//           >
//             NO
//           </button>
//         </div>
//       </div>
//     );

//     setActiveImg(InterogativeImg);
//     setIsMessageBoxVisible(true);
//   };

//   const executeStatusToggle = async () => {
//     setIsMessageBoxVisible(false);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Processing...</span>
//         </div>
//       </div>
//     );
//     setActiveImg(SuccessImg);
//     setIsMessageBoxVisible(true);

//     try {
//       const flag = UserStatus === "Inactive" ? 1 : 0;
//       const url = `${EndPoints.ActivateDeactivateUser}?username=${userNameForShow}&client_id=${clientId}&flag=${flag}&modified_by=${ModifierUser}`;
//       const response = await fetch(url, { method: "PATCH", headers: { accept: "application/json", Authorization: `Bearer ${accessToken}` } });
//       if (!response.ok) throw new Error(`Failed: ${response.status}`);
//       const result = await response.json();
//       if (result.status === 200) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{result?.message || `User ${flag === 1 ? "activated" : "deactivated"} successfully`}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(SuccessImg);
//         setIsMessageBoxVisible(true);
//         setTimeout(() => {
//           setIsMessageBoxVisible(false);
//           navigate(-1);
//         }, 1500);
//       } else {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{result?.message || "User not Updated"}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//       }
//     } catch (err) {
//       console.error("Error toggling user status:", err);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{`Failed to ${UserStatus === "Inactive" ? "activate" : "deactivate"} user`}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//       setIsMessageBoxVisible(true);
//     }
//   };

//   const handleCancelConfirmation = () => setIsMessageBoxVisible(false);

//   const handleResetPassword = () => {
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
//           <div style={{ display: "flex", gap: "15px" }}>
//             <div className="loader-tc"></div>
//             <span style={{ textAlign: "left", flex: "1" }}>Are you sure you want to reset the password for this user?</span>
//           </div>
//           <div style={{ display: "flex", gap: "15px" }}>
//             <button className="create-test-section-btn-v3" onClick={executeResetPassword} style={{ boxShadow: "0px 4px 4px 0px #00000040" }}>OK</button>
//             <button className="create-test-section-btn-v3" onClick={handleCancelConfirmation} style={{ boxShadow: "0px 4px 4px 0px #00000040" }}>CANCEL</button>
//           </div>
//         </div>
//       </div>
//     );
//     setActiveImg(InterogativeImg);
//     setIsMessageBoxVisible(true);
//   };

//   const executeResetPassword = async () => {
//     setIsMessageBoxVisible(false);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Processing password reset...</span>
//         </div>
//       </div>
//     );
//     setActiveImg(SuccessImg);
//     setIsMessageBoxVisible(true);

//     try {
//       if (!userNameForShow || !ModifierUser) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>User information not available for password reset.</span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//         return;
//       }

//       const url = `${EndPoints.UpdateUser}?username=${userNameForShow}&modified_by=${ModifierUser}&reset_password_flag=1`;
//       const response = await fetch(url, { method: "PUT", headers: { accept: "application/json", Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" }, body: JSON.stringify([]) });
//       if (!response.ok) throw new Error(`Reset password failed with status ${response.status}`);
//       const result = await response.json();

//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{result?.message || "Password reset successfully!"}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(SuccessImg);
//       setIsMessageBoxVisible(true);

//       localStorage.removeItem("isLoggedIn");
//       localStorage.removeItem("userId");
//       localStorage.removeItem("clientId");
//       setTimeout(() => setIsMessageBoxVisible(false), 2000);
//       setTimeout(() => window.location.reload(), 1000);
//     } catch (error) {
//       console.error("Error resetting password:", error);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{`Password reset failed: ${error.message}`}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//       setIsMessageBoxVisible(true);
//     }
//   };

//   const handleDeleteRoleFromGroup = (groupName, roleNameToRemove) => {
//     setGroupedRows((prev) => prev.map((g) => (g.group_name === groupName ? { ...g, roles: g.roles.filter((r) => r.role_name !== roleNameToRemove) } : g)));
//   };

//   // ---------- New UI state logic ----------
//   const isInactive = !!UserStatus && String(UserStatus).toLowerCase() === "inactive";
//   // When viewing an inactive user: edit & reset password should be disabled
//   const disableEditButton = isInactive;
//   const disableResetPasswordButton = isSameUser || isInactive; // keep previous same-user behavior + inactive case
//   // When same logged-in user viewing their own details: deactivate button should be disabled
//   const disableDeactivateButton = isSameUser;

//   return (
//     <div className="Leftmargin-Main-DIV">
//       <div style={{ position: "sticky", top: 0, backgroundColor: "white", zIndex: 100 }}>
//         <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "20px", width: "98%" }}>
//           <div style={{ fontSize: "30px", color: `${Colors.color1}`, fontWeight: "400" }}>Application User Details</div>
//           <div>
//             <div className="row-cs-uni">
//               <button className="create-test-section-btn" style={{ marginRight: "18px", boxShadow: "0px 4px 4px 0px #00000040" }} onClick={handleCancelClick}>CANCEL</button>

//               <button
//                 className="create-test-section-btn"
//                 style={{
//                   marginRight: "18px",
//                   boxShadow: "0px 4px 4px 0px #00000040",
//                   width: "150px",
//                   opacity: disableResetPasswordButton ? 0.5 : 1,
//                   cursor: disableResetPasswordButton ? "not-allowed" : "pointer",
//                 }}
//                 onClick={() => {
//                   if (!disableResetPasswordButton) handleResetPassword();
//                 }}
//                 disabled={disableResetPasswordButton}
//               >
//                 RESET PASSWORD
//               </button>

//               <button
//                 className="create-test-section-btn"
//                 style={{
//                   marginRight: "18px",
//                   boxShadow: "0px 4px 4px 0px #00000040",
//                   opacity: disableDeactivateButton ? 0.5 : 1,
//                   cursor: disableDeactivateButton ? "not-allowed" : "pointer",
//                 }}
//                 onClick={() => {
//                   if (!disableDeactivateButton) handleStatusToggleClick();
//                 }}
//                 disabled={disableDeactivateButton}
//               >
//                 {UserStatus === "Inactive" ? "ACTIVATE" : "DEACTIVATE"}
//               </button>

//               {!isEditMode ? (
//                 <button
//                   className="create-test-section-btn"
//                   style={{
//                     marginRight: "0px",
//                     opacity: disableEditButton ? 0.5 : 1,
//                     cursor: disableEditButton ? "not-allowed" : "pointer",
//                   }}
//                   onClick={() => {
//                     if (!disableEditButton) handleEditClick();
//                   }}
//                   disabled={disableEditButton}
//                 >
//                   EDIT
//                 </button>
//               ) : (
//                 <button className="create-test-section-btn" style={{ marginRight: "0px" }} onClick={handleSaveClick}>SAVE</button>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="Header-1-C424342" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "5px" }}>
//         <span>USER INFORMATION</span>
//         <img src={MinusImg} alt="Toggle" style={{ cursor: "pointer", width: "24px", height: "10px" }} />
//       </div>

//       <div className="Body-1-C424342" style={{ paddingBottom: "10px" }}>
//         <div className="row-cs-uni">
//           <div className="col-cs-uni"><InputComponent2 label="User Name" value={userNameForShow} style={{ width: "95%" }} isRequired={false} disable={true} /></div>
//           <div className="col-cs-uni"><InputComponent label="Employee Name" value={`${employeeData.emp_first_name || ""} ${employeeData.emp_middle_name || ""} ${employeeData.emp_last_name || ""}`.trim()} style={{ width: "95%" }} isRequired={false} disable={true} /></div>
//           <div className="col-cs-uni"><InputComponent label="Staff Number" value={employeeData.staff_number || ""} style={{ width: "95%" }} isRequired={false} disable={true} /></div>
//         </div>

//         <div className="row-cs-uni">
//           <div className="col-cs-uni"><InputComponent label="Department" value={employeeData.department || ""} style={{ width: "95%" }} isRequired={false} disable={true} /></div>
//           <div className="col-cs-uni"><InputComponent label="Designation" value={employeeData.designation || ""} style={{ width: "95%" }} isRequired={false} disable={true} /></div>
//           <div className="col-cs-uni"><InputComponent label="Manager Name" value={employeeData.manager_name || "Not Assigned"} style={{ width: "95%" }} isRequired={false} disable={true} /></div>
//         </div>

//         <div className="row-cs-uni">
//           <div className="col-cs-uni"><InputComponent label="User Status" value={UserStatus || ""} style={{ width: "95%" }} isRequired={false} disable={true} /></div>
//           <div className="col-cs-uni">{!isEditMode ? <InputComponent label="Application Access" value={appAccess || "Not Set"} style={{ width: "95%" }} isRequired={false} disable={true} /> : <DropDown label="Application Access" style={{ width: "95%" }} setSelected={setAppAccess} selected={appAccess} options={appAccessOptions} isRequired={true} />}</div>
//           <div className="col-cs-uni"><InputComponent label="Approved by" value={employeeData.approved_by || ""} style={{ width: "95%" }} isRequired={false} disable={true} /></div>
//         </div>
//       </div>

//       <div className="Header-1-C424342" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "5px", marginTop: "30px" }}>
//         <span>USER GROUPS</span>
//         <img src={MinusImg} alt="Toggle" style={{ cursor: "pointer", width: "24px", height: "10px" }} />
//       </div>

//       <div className="Body-1-C424342" style={{ marginBottom: "50px" }}>
//         {Array.isArray(groupedRows) && groupedRows.length > 0 ? (
//           <TableForAccessView
//             headers={sampleHeaders}
//             data={groupedRows}
//             searchPlaceholder="Search user groups..."
//             selectedRows={[]}
//             setSelectedRows={() => {}}
//             renderQuestionText={renderQuestionText}
//             renderQuestionTextModel={renderQuestionTextModel}
//             expandedStates={{}}
//             toggleImage={() => {}}
//             questionDetailsMap={{}}
//             handleEyeClick={() => {}}
//             pageType="userGroups"
//             onRowLinkClick={(row) => console.log("Row clicked:", row)}
//             filterConfig={{}}
//             handleDeleteRow={(payload) => {
//               handleDeleteRoleFromGroup(payload.groupName, payload.roleName);
//             }}
//           />
//         ) : (
//           <div style={{ padding: "28px 0", textAlign: "center", color: "#999", fontStyle: "italic" }}>
//             No screens available
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default UserEditFromDashboard;

// UserEditFromDashboard.jsx
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Colors from "../../../Constants/Colors";
import InputComponent from "../../CreateQuestionsPaper/TestScheduling/Input-testscheduling";
import EndPoints from "../../../Api/EndPoints";
import { GET, PUT } from "../../../Api/HttpsMethods";
import TableForUserEdit from "../../../Components/TableComponent/TableForUserEdit";
import TableForAccessView from "../../../Components/TableComponent/TableForAccessView";
import InputComponent2 from "../../../Components/InputComponents/InputComponent";
import DropDown from "../../CreateQuestionsPaper/DppScheduling/ReflectDropdownClassic";
import MinusImg from "../../../Assets/Images/CommanImages/MinusGrey.png";
import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
import SuccessImg from "../../../Assets/Images/CommanImages/success.png";
import InterogativeImg from "../../../Assets/Images/CommanImages/Interogative.png";
import { FULL_API_BASE_URL } from "../../../Config/Config";

/**
 * UserEditFromDashboard
 * - Calls: GET /coaching-collaborator-api/api/v1/get-user-group-role-screen-report-access-details-by-user-id?user_id=<UserId>
 * - Sends Authorization: Bearer <token> when available.
 * - Shows auth error message in message box if token missing or invalid.
 * - Shows "No screens available" centered when API returns empty data.
 */

const UserEditFromDashboard = ({
  dataClient,
  messageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  setMessageBox,
}) => {
  const [employeeData, setEmployeeData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userNameForShow, setUserNameForShow] = useState("");
  const [appAccess, setAppAccess] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [UserStatus, setUserStatus] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  const sampleHeaders = ["User Groups", "Roles", "Screens", "Reports"];
  const [assignedRoles, setAssignedRoles] = useState([]);
  const [groupedRows, setGroupedRows] = useState([]);

  const accessToken = localStorage.getItem("other"); // token used for Authorization
  const ModifierUser =
    dataClient?.client_schema_name?.[6]?.[0]?.user_name ||
    sessionStorage.getItem("user_name") ||
    "";
  const clientId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_id ||
    localStorage.getItem("clientId") ||
    sessionStorage.getItem("clientId");
  const UserId = new URLSearchParams(location.search).get("UserID") || ""; // user_id to send to API
  const loggedInUserId =
    dataClient?.dataClient?.client_schema_name?.[6]?.[0]?.user_id ||
    localStorage.getItem("userId") ||
    sessionStorage.getItem("userId");
  const isSameUser =
    UserId && loggedInUserId && UserId === loggedInUserId.toString();

  useEffect(() => {
    const usernameFromUrl = new URLSearchParams(location.search).get(
      "UsernameOfEmployee"
    );
    if (usernameFromUrl) setUserNameForShow(usernameFromUrl);
  }, [location.search]);

  const appAccessOptions = [
    { label: "Web Portal", id: "Web Portal" },
    { label: "Mobile Application", id: "Mobile Application" },
    { label: "Both", id: "Both" },
  ];

  // fetchRoles kept for compatibility (your code had it)
  const fetchRoles = async () => {
    try {
      if (EndPoints.GetRoles) await GET.noToken(EndPoints.GetRoles);
    } catch (err) {
      console.error("Error fetching roles:", err);
    }
  };

  useEffect(() => {
    fetchRoles();
    // eslint-disable-next-line
  }, []);

  // Fetch employee data (unchanged)
  const fetchEmployeeData = async (searchKey) => {
    try {
      setLoading(true);
      if (setMessageBox) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Loading employee data...</span>
            </div>
          </div>
        );
        setActiveImg && setActiveImg(SuccessImg);
        setIsMessageBoxVisible && setIsMessageBoxVisible(true);
      }

      const url = `${EndPoints.GetEmployeeBySearchKey}?search_key=${searchKey}`;
      const data = await GET.noToken(url);

      if (data && data.length > 0) {
        setEmployeeData(data[0]);
        setAppAccess(
          getAppAccessValue(data[0].mobile_app_user, data[0].web_app_user)
        );
        setUserStatus(data[0].user_status || "");
      } else {
        setError("No employee data found");
      }
    } catch (err) {
      setError(`Failed to fetch employee data: ${err.message}`);
      console.error("Error fetching employee data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const searchKey = new URLSearchParams(location.search).get(
      "MNTQuestionNumbers"
    );
    if (searchKey) fetchEmployeeData(searchKey);
    else {
      setError(null);
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [location.search]);

  // New: fetch user groups/access info from API using only user_id and send Authorization header
  useEffect(() => {
    const fetchAccessInfo = async () => {
      if (!UserId) {
        setGroupedRows([]);
        return;
      }

      // if no token, show message and still try if your API allows anonymous (but here it returned auth error)
      if (!accessToken) {
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Not authenticated (missing token). Please login.</span>
              </div>
            </div>
          );
          setActiveImg && setActiveImg(ErrorImg);
          setIsMessageBoxVisible && setIsMessageBoxVisible(true);
        }
        setGroupedRows([]);
        return;
      }

      try {
        const base =
          EndPoints.GetUserGroupAccessByUserId ||
          `${FULL_API_BASE_URL}/get-user-group-role-screen-report-access-details-by-user-id`;
        const url = `${base}?user_id=${encodeURIComponent(UserId)}`;

        const res = await fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });

        // handle authentication errors explicitly
        if (res.status === 401 || res.status === 403) {
          const txt = await res.text().catch(() => "");
          const shortMsg = txt || "Not authenticated";
          if (setMessageBox) {
            setMessageBox(
              <div className="Container-messageBOX">
                <div className="messagebox-insider1">
                  <div className="loader-tc"></div>
                  <span>{shortMsg}</span>
                </div>
              </div>
            );
            setActiveImg && setActiveImg(ErrorImg);
            setIsMessageBoxVisible && setIsMessageBoxVisible(true);
          }
          setGroupedRows([]);
          return;
        }

        const json = await res.json().catch(() => null);

        // API expected format: { status:200, message, data: [...] } OR directly an array
        let dataArray = [];
        if (!json) {
          dataArray = [];
        } else if (Array.isArray(json)) {
          dataArray = json;
        } else if (Array.isArray(json.data)) {
          dataArray = json.data;
        } else {
          dataArray = [];
        }

        if (dataArray.length > 0) {
          setGroupedRows(dataArray);
        } else {
          setGroupedRows([]);
          // show subtle message (but don't spam) — keep quiet here unless you want visible message
        }
      } catch (err) {
        console.error("Error fetching access info:", err);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Error fetching access info</span>
              </div>
            </div>
          );
          setActiveImg && setActiveImg(ErrorImg);
          setIsMessageBoxVisible && setIsMessageBoxVisible(true);
        }
        setGroupedRows([]);
      }
    };

    fetchAccessInfo();
    // eslint-disable-next-line
  }, [UserId, accessToken]);

  const renderQuestionText = (text) => (text ? text : "");
  const renderQuestionTextModel = (text) => (text ? text : "");

  const handleEditClick = () => setIsEditMode(true);

  const handleSaveClick = async () => {
    try {
      let webUserFlag = 0;
      let appUserFlag = 0;
      if (appAccess === "Both") {
        webUserFlag = 1;
        appUserFlag = 1;
      } else if (appAccess === "Mobile Application") {
        appUserFlag = 1;
        webUserFlag = 0;
      } else if (appAccess === "Web Portal") {
        webUserFlag = 1;
        appUserFlag = 0;
      }
      const url = `${EndPoints.UpdateUser}?username=${userNameForShow}&modified_by=${ModifierUser}&web_user_flag=${webUserFlag}&app_user_flag=${appUserFlag}`;
      const result = await PUT.withToken(url, assignedRoles);
      if (result?.status === 200) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{result?.message || "User Data Updated successfully"}</span>
            </div>
          </div>
        );
        setActiveImg(SuccessImg);
        setIsMessageBoxVisible(true);
        setTimeout(() => {
          setIsMessageBoxVisible(false);
          navigate(-1);
        }, 1500);
      } else {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{result?.message || "User Data Could not Update"}</span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        setIsMessageBoxVisible(true);
      }
    } catch (err) {
      console.error("Error saving data:", err);
      alert("Failed to save data");
    }
  };

  const handleCancelClick = () => navigate(-1);

  const getAppAccessValue = (mobile_app_user, webUserValue) => {
    if (mobile_app_user === 1 && webUserValue === 1) return "Both";
    if (mobile_app_user === 1 && webUserValue !== 1)
      return "Mobile Application";
    if (webUserValue === 1 && mobile_app_user !== 1) return "Web Portal";
    return "";
  };

  // const handleStatusToggleClick = () => {
  //   setMessageBox(
  //     <div className="Container-messageBOX">
  //       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
  //         <div style={{ display: "flex", gap: "15px" }}>
  //           <div className="loader-tc"></div>
  //           <span style={{ textAlign: "left", flex: "1" }}>Are you sure you want to {UserStatus === "Inactive" ? "activate" : "deactivate"} this user?</span>
  //         </div>
  //         <div style={{ display: "flex", gap: "15px" }}>
  //           <button className="create-test-section-btn-v3" onClick={executeStatusToggle} style={{ boxShadow: "0px 4px 4px 0px #00000040" }}>OK</button>
  //           <button className="create-test-section-btn-v3" onClick={handleCancelConfirmation} style={{ boxShadow: "0px 4px 4px 0px #00000040" }}>CANCEL</button>
  //         </div>
  //       </div>
  //     </div>
  //   );
  //   setActiveImg(InterogativeImg);
  //   setIsMessageBoxVisible(true);
  // };

  const handleStatusToggleClick = () => {
    const isActivating = UserStatus === "Inactive";

    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>
            {isActivating
              ? "Are you sure you want to activate this user?"
              : "Are you sure you want to deactivate this user?"}
          </span>
        </div>

        <div
          className="messagebox-insider2"
          style={{
            display: "flex",
            gap: "10px",
            marginTop: "10px",
            justifyContent: "flex-end",
          }}
        >
          {/* YES button */}
          <button
            className="messagebox-cancel-btn-ok"
            onClick={() => {
              setIsMessageBoxVisible(false);
              executeStatusToggle(); // same logic as before
            }}
          >
            YES
          </button>

          {/* NO button */}
          <button
            className="messagebox-cancel-btn-ok"
            onClick={() => {
              setIsMessageBoxVisible(false);
              handleCancelConfirmation(); // same cancel callback as before
            }}
          >
            NO
          </button>
        </div>
      </div>
    );

    setActiveImg(InterogativeImg);
    setIsMessageBoxVisible(true);
  };

  const executeStatusToggle = async () => {
    setIsMessageBoxVisible(false);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>Processing...</span>
        </div>
      </div>
    );
    setActiveImg(SuccessImg);
    setIsMessageBoxVisible(true);

    try {
      const flag = UserStatus === "Inactive" ? 1 : 0;
      const url = `${EndPoints.ActivateDeactivateUser}?username=${userNameForShow}&client_id=${clientId}&flag=${flag}&modified_by=${ModifierUser}`;
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (!response.ok) throw new Error(`Failed: ${response.status}`);
      const result = await response.json();
      if (result.status === 200) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                {result?.message ||
                  `User ${
                    flag === 1 ? "activated" : "deactivated"
                  } successfully`}
              </span>
            </div>
          </div>
        );
        setActiveImg(SuccessImg);
        setIsMessageBoxVisible(true);
        setTimeout(() => {
          setIsMessageBoxVisible(false);
          navigate(-1);
        }, 1500);
      } else {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{result?.message || "User not Updated"}</span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        setIsMessageBoxVisible(true);
      }
    } catch (err) {
      console.error("Error toggling user status:", err);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{`Failed to ${
              UserStatus === "Inactive" ? "activate" : "deactivate"
            } user`}</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsMessageBoxVisible(true);
    }
  };

  const handleCancelConfirmation = () => setIsMessageBoxVisible(false);

  // UPDATED: Reset password confirmation UI now matches deactivate UI (YES / NO)
  const handleResetPassword = () => {
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>
            Are you sure you want to reset the password for this user?
          </span>
        </div>

        <div
          className="messagebox-insider2"
          style={{
            display: "flex",
            gap: "10px",
            marginTop: "10px",
            justifyContent: "flex-end",
          }}
        >
          {/* YES button */}
          <button
            className="messagebox-cancel-btn-ok"
            onClick={() => {
              setIsMessageBoxVisible(false);
              executeResetPassword();
            }}
          >
            YES
          </button>

          {/* NO button */}
          <button
            className="messagebox-cancel-btn-ok"
            onClick={() => {
              setIsMessageBoxVisible(false);
              handleCancelConfirmation();
            }}
          >
            NO
          </button>
        </div>
      </div>
    );
    setActiveImg(InterogativeImg);
    setIsMessageBoxVisible(true);
  };

  const executeResetPassword = async () => {
    setIsMessageBoxVisible(false);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>Processing password reset...</span>
        </div>
      </div>
    );
    setActiveImg(SuccessImg);
    setIsMessageBoxVisible(true);

    try {
      if (!userNameForShow || !ModifierUser) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>User information not available for password reset.</span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        setIsMessageBoxVisible(true);
        return;
      }

      const url = `${EndPoints.UpdateUser}?username=${userNameForShow}&modified_by=${ModifierUser}&reset_password_flag=1`;
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify([]),
      });
      if (!response.ok)
        throw new Error(`Reset password failed with status ${response.status}`);
      const result = await response.json();

      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{result?.message || "Password reset successfully!"}</span>
          </div>
        </div>
      );
      setActiveImg(SuccessImg);
      setIsMessageBoxVisible(true);

      // localStorage.removeItem("isLoggedIn");
      // localStorage.removeItem("userId");
      // localStorage.removeItem("clientId");
      setTimeout(() => setIsMessageBoxVisible(false), 2000);
      // setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      console.error("Error resetting password:", error);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{`Password reset failed: ${error.message}`}</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsMessageBoxVisible(true);
    }
  };

  const handleDeleteRoleFromGroup = (groupName, roleNameToRemove) => {
    setGroupedRows((prev) =>
      prev.map((g) =>
        g.group_name === groupName
          ? {
              ...g,
              roles: g.roles.filter((r) => r.role_name !== roleNameToRemove),
            }
          : g
      )
    );
  };

  // ---------- New UI state logic ----------
  const isInactive =
    !!UserStatus && String(UserStatus).toLowerCase() === "inactive";
  // When viewing an inactive user: edit & reset password should be disabled
  const disableEditButton = isInactive;
  const disableResetPasswordButton = isSameUser || isInactive; // keep previous same-user behavior + inactive case
  // When same logged-in user viewing their own details: deactivate button should be disabled
  const disableDeactivateButton = isSameUser;

  return (
    <div className="Leftmargin-Main-DIV">
      <div
        style={{
          position: "sticky",
          top: 0,
          backgroundColor: "white",
          zIndex: 100,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "20px",
            width: "98%",
          }}
        >
          <div
            style={{
              fontSize: "30px",
              color: `${Colors.color1}`,
              fontWeight: "400",
            }}
          >
            Application User Details
          </div>
          <div>
            <div className="row-cs-uni">
              <button
                className="create-test-section-btn"
                style={{
                  marginRight: "18px",
                  boxShadow: "0px 4px 4px 0px #00000040",
                }}
                onClick={handleCancelClick}
              >
                CANCEL
              </button>

              <button
                className="create-test-section-btn"
                style={{
                  marginRight: "18px",
                  boxShadow: "0px 4px 4px 0px #00000040",
                  width: "150px",
                  opacity: disableResetPasswordButton ? 0.5 : 1,
                  cursor: disableResetPasswordButton
                    ? "not-allowed"
                    : "pointer",
                }}
                onClick={() => {
                  if (!disableResetPasswordButton) handleResetPassword();
                }}
                disabled={disableResetPasswordButton}
              >
                RESET PASSWORD
              </button>

              <button
                className="create-test-section-btn"
                style={{
                  marginRight: "18px",
                  boxShadow: "0px 4px 4px 0px #00000040",
                  opacity: disableDeactivateButton ? 0.5 : 1,
                  cursor: disableDeactivateButton ? "not-allowed" : "pointer",
                }}
                onClick={() => {
                  if (!disableDeactivateButton) handleStatusToggleClick();
                }}
                disabled={disableDeactivateButton}
              >
                {UserStatus === "Inactive" ? "ACTIVATE" : "DEACTIVATE"}
              </button>

              {!isEditMode ? (
                <button
                  className="create-test-section-btn"
                  style={{
                    marginRight: "0px",
                    opacity: disableEditButton ? 0.5 : 1,
                    cursor: disableEditButton ? "not-allowed" : "pointer",
                  }}
                  onClick={() => {
                    if (!disableEditButton) handleEditClick();
                  }}
                  disabled={disableEditButton}
                >
                  EDIT
                </button>
              ) : (
                <button
                  className="create-test-section-btn"
                  style={{ marginRight: "0px" }}
                  onClick={handleSaveClick}
                >
                  SAVE
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      <div
        className="Header-1-C424342"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "5px",
        }}
      >
        <span>USER INFORMATION</span>
        <img
          src={MinusImg}
          alt="Toggle"
          style={{ cursor: "pointer", width: "24px", height: "10px" }}
        />
      </div>

      <div className="Body-1-C424342" style={{ paddingBottom: "10px" }}>
        <div className="row-cs-uni">
          <div className="col-cs-uni">
            <InputComponent2
              label="User Name"
              value={userNameForShow}
              style={{ width: "95%" }}
              isRequired={false}
              disable={true}
            />
          </div>
          {/* <div className="col-cs-uni"><InputComponent label="Employee Name" value={`${employeeData.emp_first_name || ""} ${employeeData.emp_middle_name || ""} ${employeeData.emp_last_name || ""}`.trim()} style={{ width: "95%" }} isRequired={false} disable={true} /></div> */}
          <div className="col-cs-uni">
            <InputComponent
              label="Employee Name"
              value={`${employeeData.emp_last_name || ""}, ${
                employeeData.emp_middle_name || ""
              } ${employeeData.emp_first_name || ""}`.trim()}
              style={{ width: "95%" }}
              isRequired={false}
              disable={true}
            />
          </div>
          <div className="col-cs-uni">
            <InputComponent
              label="Staff Number"
              value={employeeData.staff_number || ""}
              style={{ width: "95%" }}
              isRequired={false}
              disable={true}
            />
          </div>
        </div>

        <div className="row-cs-uni">
          <div className="col-cs-uni">
            <InputComponent
              label="Department"
              value={employeeData.department || ""}
              style={{ width: "95%" }}
              isRequired={false}
              disable={true}
            />
          </div>
          <div className="col-cs-uni">
            <InputComponent
              label="Designation"
              value={employeeData.designation || ""}
              style={{ width: "95%" }}
              isRequired={false}
              disable={true}
            />
          </div>
          <div className="col-cs-uni">
            <InputComponent
              label="Manager Name"
              value={employeeData.manager_name || "Not Assigned"}
              style={{ width: "95%" }}
              isRequired={false}
              disable={true}
            />
          </div>
        </div>

        <div className="row-cs-uni">
          <div className="col-cs-uni">
            <InputComponent
              label="User Status"
              value={UserStatus || ""}
              style={{ width: "95%" }}
              isRequired={false}
              disable={true}
            />
          </div>
          <div className="col-cs-uni">
            {!isEditMode ? (
              <InputComponent
                label="Application Access"
                value={appAccess || "Not Set"}
                style={{ width: "95%" }}
                isRequired={false}
                disable={true}
              />
            ) : (
              <DropDown
                label="Application Access"
                style={{ width: "95%" }}
                setSelected={setAppAccess}
                selected={appAccess}
                options={appAccessOptions}
                isRequired={true}
              />
            )}
          </div>
          <div className="col-cs-uni">
            <InputComponent
              label="Approved by"
              value={employeeData.approved_by || ""}
              style={{ width: "95%" }}
              isRequired={false}
              disable={true}
            />
          </div>
        </div>
      </div>

      <div
        className="Header-1-C424342"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "5px",
          marginTop: "30px",
        }}
      >
        <span>USER GROUPS</span>
        <img
          src={MinusImg}
          alt="Toggle"
          style={{ cursor: "pointer", width: "24px", height: "10px" }}
        />
      </div>

      <div className="Body-1-C424342" style={{ marginBottom: "50px" }}>
        {Array.isArray(groupedRows) && groupedRows.length > 0 ? (
          <TableForAccessView
            headers={sampleHeaders}
            data={groupedRows}
            searchPlaceholder="Search user groups..."
            selectedRows={[]}
            setSelectedRows={() => {}}
            renderQuestionText={renderQuestionText}
            renderQuestionTextModel={renderQuestionTextModel}
            expandedStates={{}}
            toggleImage={() => {}}
            questionDetailsMap={{}}
            handleEyeClick={() => {}}
            pageType="userGroups"
            onRowLinkClick={(row) => console.log("Row clicked:", row)}
            filterConfig={{}}
            handleDeleteRow={(payload) => {
              handleDeleteRoleFromGroup(payload.groupName, payload.roleName);
            }}
          />
        ) : (
          <div
            style={{
              padding: "28px 0",
              textAlign: "center",
              color: "#999",
              fontStyle: "italic",
            }}
          >
            No screens available
          </div>
        )}
      </div>
    </div>
  );
};

export default UserEditFromDashboard;
